module.exports = __webpack_public_path__ + "static/media/hub_bulk_upload_template.6013e9cf.csv";